import React from 'react';

import Badge from 'ui/Badge';
import EmptyState from 'ui/EmptyState';
import { HStack } from 'ui/Layout';

import { useTeamSankeysQuery } from '../../api';
import { useCurrentUser } from '../../utils/user';
import MyDiagramSlotsBadge from '../MyDiagramSlotsBadge';
import DiagramsListing from './DiagramsListing';
import NewDiagramButton from './NewDiagramButton';
import NoOrganizationDiagramsCTA from './NoOrganizationDiagramsCTA';

type Props = {
  currentSankeyId?: number;
  onSelect?: () => void;
};

const DiagramsOverview: React.FC<Props> = ({ currentSankeyId, onSelect }) => {
  const { user } = useCurrentUser();
  const query = useTeamSankeysQuery();

  const sankeys = query.data ?? [];
  const mySankeys = sankeys.filter((sankey) => sankey.owner_id === user?.id);
  const orgSankeys = sankeys.filter((sankey) => sankey.owner_id !== user?.id);

  return (
    <HStack alignItems="flex-start" flexWrap="wrap" gap={8} py={1} w="100%">
      <DiagramsListing
        currentSankeyId={currentSankeyId}
        onSelect={onSelect}
        title="My diagrams"
        headerContent={
          <HStack gap={4}>
            <MyDiagramSlotsBadge />
            {!currentSankeyId && <NewDiagramButton />}
          </HStack>
        }
        emptyContent={
          <EmptyState
            icon="copy-regular"
            title="You have no saved diagrams"
            description="Please create a new diagram for it to appear here"
            background="gray.50"
          />
        }
        sankeys={mySankeys}
        isLoading={query.isLoading}
        refetchDiagrams={query.refetch}
        canDelete
      />
      <DiagramsListing
        currentSankeyId={currentSankeyId}
        onSelect={onSelect}
        title="Organization diagrams"
        headerContent={
          <Badge colorPalette="gray" variant="surface">
            {orgSankeys.length}
          </Badge>
        }
        emptyContent={<NoOrganizationDiagramsCTA />}
        sankeys={orgSankeys}
        isLoading={query.isLoading}
        refetchDiagrams={query.refetch}
      />
    </HStack>
  );
};

export default DiagramsOverview;
